<template>
  <panel-layout
    id="customer-panel"
    class="h-full w-full flex flex-col bg-gray-100"
    :loading="loading"
    :heading="customer ? customer.displayName : ''"
    :show-footer="false"
  >
    <chat v-if="customer" :id-customer="idCustomer" />
  </panel-layout>
</template>
<script setup lang="ts">
// @ts-ignore
import Chat from '@/components/message/elements/Chat.vue'
// @ts-ignore
import PanelLayout from '@/components/panel/PanelLayout.vue'

import { usePanel } from '~/composables/usePanel'

const { $api } = useNuxtApp()

const panel = usePanel()

const props = defineProps<{ id?: string }>()

const customer = ref<any>(null)
const loading = ref(false)

const idCustomer = computed(() => props.id)

const fetchCustomer = async (id?: string) => {
  loading.value = true

  try {
    if (id) {
      const c = (await $api.customer.get(id)).data
      customer.value = c
    }
  } catch (e: any) {
    console.log(e)
  }

  loading.value = false
}

watch(() => props.id, (id) => fetchCustomer(id), { immediate: true })
</script>
